import { Helmet } from 'react-helmet';
import React, { Fragment } from 'react';
import { LanguageContext } from '../components/i18n/LanguageContext';

const HelmetProvider = page => Component => props => (
  <LanguageContext.Consumer>
    {({ content }) => (
      <Fragment>
        <Helmet>
          <title>{content.metatags(page).title}</title>
          <meta
            name="description"
            content={content.metatags(page).description}
          />
        </Helmet>
        <Component {...props} content={content} />
      </Fragment>
    )}
  </LanguageContext.Consumer>
);

export default HelmetProvider;
